import { RootState } from "@/modules/common";

export const selectHasSaturdayDeliveryProduct = (state: RootState) =>
  state.basket.saturdayDeliveryProduct;
